<div
  [class]="'relative'"
  [style]="{
    width: boxSize() + 'px',
    height: boxSize() + 'px',
  }"
>
  <svg class="absolute overflow-visible inset-0 w-full h-full rotate-[-90deg] z-[1]">
    <defs>
      <radialGradient
        id="progressGradient-custom-{{ id() }}"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        [attr.gradientTransform]="'translate(82 108) rotate(121.171) scale(108.564 108.564)'"
      >
        <stop offset="58.75%" stop-color="#00B7DF" />
        <stop offset="100%" stop-color="#FFA800" />
      </radialGradient>
      <radialGradient
        id="progressGradient-full-{{ id() }}"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        [attr.gradientTransform]="'translate(82 108) rotate(121.171) scale(108.564 108.564)'"
      >
        <stop offset="0%" stop-color="#00B7DF" />
        <stop offset="100%" stop-color="#00B7DF" />
      </radialGradient>
    </defs>

    <!-- Background circle -->
    @if (hasBackground()) {
      <circle
        stroke="currentColor"
        [attr.stroke-width]="strokeWidth()"
        fill="transparent"
        [attr.r]="radius()"
        [attr.cx]="center()"
        [attr.cy]="center()"
        class="text-gray-300"
      />
    }

    <!-- Progress circle -->
    <circle
      [attr.stroke]="
        'url(' + (this.percentage() < 100 ? '#progressGradient-custom-' : '#progressGradient-full-') + id() + ')'
      "
      [attr.stroke-width]="strokeWidth() * 2"
      fill="transparent"
      [attr.r]="radius()"
      [attr.cx]="center()"
      [attr.cy]="center()"
      [attr.stroke-dasharray]="circumference()"
      [attr.stroke-dashoffset]="dashOffset()"
      stroke-linecap="round"
    />
  </svg>

  <ng-content></ng-content>

  @if (hasLabel()) {
    <div class="absolute inset-0 flex items-center justify-center text-sm font-bold text-gray-800">
      {{ percentage() }}%
    </div>
  }
</div>
